import { useQuery } from "@apollo/client/react";
import { Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import DataGridGenerico from "../../../../../components/dataGrid/DataGridGenerico";
import DocumentViewer from '../../../../../components/DocumentViewer';

import GET_DOCUMENTOS_CARGADOS, { adaptDocumentosArray } from "../../../../../data/graphQL/queries/GestionAsistencial/getDocumentosCargadosAsistencial";
import { useTabDocumentacion } from "../../hooks/TabDocumentacion/useTabDocumentacion";

export function TabDocumentacionArchivosCargados({
  evaluacionSelected
}) {
  const { idEvaluacion } = evaluacionSelected;
  const [documentos, setDocumentos] = useState([]);
  const { columns, fileToView, resetFileToView } = useTabDocumentacion('archivosCargados', documentos);

  const { data: dataDocumentosCargados } = useQuery(GET_DOCUMENTOS_CARGADOS, {
    variables: { idEvaluacion: idEvaluacion },
    fetchPolicy: "no-cache"
  });

  useEffect(() => {
    if (!dataDocumentosCargados) return;
    const dataDocumentos = dataDocumentosCargados;
    setDocumentos(adaptDocumentosArray(dataDocumentos));
  }, [dataDocumentosCargados]);

  return (
    <div className='generic-tab-container' style={{ marginTop: "20px" }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography sx={{ fontSize: "16px", fontWeight: "600", mb: "20px" }}>
            Archivos Cargados
          </Typography>
          <DataGridGenerico
            columns={columns}
            rows={documentos}
            totalCount={documentos?.length || 0}
            toolbar={false} />

        </Grid>
      </Grid>
      {fileToView && <DocumentViewer data={fileToView} setOpenDlg={resetFileToView} download={true} />}
    </div>);

}